/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { LoteResponse } from '../models/lote-response';
import { LoteFatura } from '../models/lote-fatura';
import { LoteFaturaPaginado } from '../models/lote-fatura-paginado';

/**
 * API responsavel pelos dados do lote de repasse/fatura
 */
@Injectable({
  providedIn: 'root',
})
class LoteFaturaService extends __BaseService {
  static readonly salvarLoteFaturaPath = '/lote-fatura';
  static readonly obterLotesPath = '/lote-fatura';
  static readonly obterLotePorNumeroPath = '/lote-fatura/{numeroLote}';
  static readonly obterRelatorioLotePath = '/lote-fatura/relatorio';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Cadastra um lote de repasse
   * @param loteFatura Objeto do lote
   * @return Operacao realizada com sucesso
   */
  salvarLoteFaturaResponse(loteFatura: LoteFatura): __Observable<__StrictHttpResponse<LoteResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = loteFatura;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/lote-fatura`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LoteResponse>;
      })
    );
  }
  /**
   * Cadastra um lote de repasse
   * @param loteFatura Objeto do lote
   * @return Operacao realizada com sucesso
   */
  salvarLoteFatura(loteFatura: LoteFatura): __Observable<LoteResponse> {
    return this.salvarLoteFaturaResponse(loteFatura).pipe(
      __map(_r => _r.body as LoteResponse)
    );
  }

  /**
   * Recupera uma listagem dos lotes com base nos parametros informados
   * @param params The `LoteFaturaService.ObterLotesParams` containing the following parameters:
   *
   * - `valorInicial`: Faixa de valor inicial na pesquisa
   *
   * - `valorFinal`: Faixa de valor final na pesquisa
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `numeroSinistro`: Numero do sinistro
   *
   * - `numeroLote`: Numero do lote
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterLotesResponse(params: LoteFaturaService.ObterLotesParams): __Observable<__StrictHttpResponse<LoteFaturaPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.valorInicial != null) __params = __params.set('valorInicial', params.valorInicial.toString());
    if (params.valorFinal != null) __params = __params.set('valorFinal', params.valorFinal.toString());
    if (params.ramoSinistro != null) __params = __params.set('ramoSinistro', params.ramoSinistro.toString());
    if (params.periodoInicial != null) __params = __params.set('periodoInicial', params.periodoInicial.toString());
    if (params.periodoFinal != null) __params = __params.set('periodoFinal', params.periodoFinal.toString());
    if (params.perPage != null) __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.numeroSinistro != null) __params = __params.set('numeroSinistro', params.numeroSinistro.toString());
    if (params.numeroLote != null) __params = __params.set('numeroLote', params.numeroLote.toString());
    if (params.codigoEscritorio != null) __params = __params.set('codigoEscritorio', params.codigoEscritorio.toString());
    if (params.anoSinistro != null) __params = __params.set('anoSinistro', params.anoSinistro.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/lote-fatura`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LoteFaturaPaginado>;
      })
    );
  }
  /**
   * Recupera uma listagem dos lotes com base nos parametros informados
   * @param params The `LoteFaturaService.ObterLotesParams` containing the following parameters:
   *
   * - `valorInicial`: Faixa de valor inicial na pesquisa
   *
   * - `valorFinal`: Faixa de valor final na pesquisa
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `numeroSinistro`: Numero do sinistro
   *
   * - `numeroLote`: Numero do lote
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterLotes(params: LoteFaturaService.ObterLotesParams): __Observable<LoteFaturaPaginado> {
    return this.obterLotesResponse(params).pipe(
      __map(_r => _r.body as LoteFaturaPaginado)
    );
  }

  /**
   * Recupera uma listagem das transacoes com base nos parametros informados
   * @param numeroLote Codigo identificador do lote
   * @return Operacao realizada com sucesso
   */
  obterLotePorNumeroResponse(numeroLote: number): __Observable<__StrictHttpResponse<LoteFatura>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/lote-fatura/${encodeURIComponent(String(numeroLote))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LoteFatura>;
      })
    );
  }
  /**
   * Recupera uma listagem das transacoes com base nos parametros informados
   * @param numeroLote Codigo identificador do lote
   * @return Operacao realizada com sucesso
   */
  obterLotePorNumero(numeroLote: number): __Observable<LoteFatura> {
    return this.obterLotePorNumeroResponse(numeroLote).pipe(
      __map(_r => _r.body as LoteFatura)
    );
  }

  /**
   * Retorna relatorio de parcelas com base na lista de parcela passada
   * @param relatorioRequest Objeto relatorio request
   * @return Relatório gerado com sucesso
   */
  obterRelatorioLoteResponse(relatorioRequest?: Array<LoteFatura>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = relatorioRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/lote-fatura/relatorio`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Retorna relatorio de parcelas com base na lista de parcela passada
   * @param relatorioRequest Objeto relatorio request
   * @return Relatório gerado com sucesso
   */
  obterRelatorioLote(relatorioRequest?: Array<LoteFatura>): __Observable<Blob> {
    return this.obterRelatorioLoteResponse(relatorioRequest).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module LoteFaturaService {

  /**
   * Parameters for obterLotes
   */
  export interface ObterLotesParams {

    /**
     * Faixa de valor inicial na pesquisa
     */
    valorInicial?: number;

    /**
     * Faixa de valor final na pesquisa
     */
    valorFinal?: number;

    /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro?: number;

    /**
     * Data inicial da pesquisa
     */
    periodoInicial?: string;

    /**
     * Data final da pesquisa
     */
    periodoFinal?: string;

    /**
     * Quantidade registros por pagina
     */
    perPage?: number;

    /**
     * Pagina inicial
     */
    page?: number;

    /**
     * Numero do sinistro
     */
    numeroSinistro?: number;

    /**
     * Numero do lote
     */
    numeroLote?: number;

    /**
     * Codigo do escritorio
     */
    codigoEscritorio?: number;

    /**
     * Ano do sinistro
     */
    anoSinistro?: number;
  }
}

export { LoteFaturaService }
